import type { FormInstance } from 'types/step';
import type { ReflexStep } from 'shiftNotes/_types';

export default function collectFilledFormInstances(
  directFormInstance: FormInstance | null | undefined,
  reflexSteps: ReflexStep[] | undefined
): FormInstance[] {
  const forms: FormInstance[] = [];
  const seen = new Set<string>();
  const consider = (formInstance: FormInstance | null | undefined) => {
    if (formInstance?.file && !seen.has(formInstance.id)) {
      forms.push(formInstance);
      seen.add(formInstance.id);
    }
  };
  consider(directFormInstance);
  reflexSteps?.forEach((step) => {
    if (step.step_type === 'prefill_form') {
      consider(step.form_instance);
    }
  });
  return forms;
}
